<template>
    <div>
        <aside class="menu my-5">
            <p class="menu-label">
                {{ $t('offices_title') }}
            </p>
            <ul class="menu-list">
                <li v-for="office in offices">
                    <a :class="{'is-active': $store.state.currentOffice == office.id}" @click.prevent="switchOffice(office.id)">
                        {{ office.name }}
                    </a>
                </li>
            </ul>
        </aside>
        <advertisements></advertisements>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import { store } from '@/store'

import Advertisements from './Advertisements'

export default {
    name: 'app-sidebar',

    components: {Advertisements},

    mixins: [helpers],

    methods: {
        switchOffice (key) {
            this.setCurrentOffice(key)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/AppSidebar.vue